import { get, post, put } from 'lib/API';
import { CREDIT_DEFAULTS } from 'constants/credit';

export const createCreditRecord = async (
  [sellerCode, buyerCode, companyId, source, businessUnitId, businessUnitCompanyId]: any[],
  { token }: any
): Promise<any> => {
  const payload: any = {
    buyerExternalCode: buyerCode,
    sellerCode,
    availableAmount: CREDIT_DEFAULTS.INITIAL_AMOUNT,
    reservedAmount: CREDIT_DEFAULTS.RESERVED_AMOUNT,
    usedAmount: CREDIT_DEFAULTS.USED_AMOUNT,
    allowNegativeBalance: CREDIT_DEFAULTS.ALLOW_NEGATIVE,
    source: source,
    companyId,
    businessUnitId,
    ...(businessUnitCompanyId && { businessUnitCompanyId })
  };

  return await post(`v1/credit/seller/${sellerCode}/buyer/${buyerCode}`, token, payload);
};

export const updateCreditRecord = async (
  [creditId, payload]: any[],
  { token }: any
): Promise<any> => {
  return await put(`v1/credit/${creditId}`, token, payload);
};

export const recheckCredit = async (
  [consignmentId, creditId]: any[],
  { token }: any
): Promise<any> => {
  return await post(`v1/credit/recheckCredit/client/${consignmentId}/${creditId}`, token);
}
export const overrideCreditTransaction = async (
  [consignmentId, creditId]: any[],
  { token }: any
): Promise<any> => {
  return await post(`v1/credit/override/${creditId}/${consignmentId}`, token);
};

export const getTransactionCreditByCode = async (
  [creditId, code]: any[],
  { token }: any
): Promise<any> => {
  return await get(`v1/credit/${creditId}/transactions/${code}`, token);
};
